var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.95 87.84"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.63 87.84l-6.45-20.82H26.76l-6.45 20.82H0L31.39 0h23.05l31.51 87.84H65.63zM54.68 51.46c-5.96-18.87-9.32-29.54-10.07-32.01s-1.29-4.43-1.61-5.86c-1.34 5.11-5.17 17.73-11.5 37.88h23.17z",
    fill: "#f59c27"
  })));
}
export default SvgA;